import { api } from "../../App/services/api";
function getAllTheArtsForTheDesigners(_a) {
    var _b = _a.per_page, per_page = _b === void 0 ? 20 : _b, page = _a.page, _c = _a.status, status = _c === void 0 ? '' : _c, _d = _a.designer, designer = _d === void 0 ? '' : _d, _e = _a.user_uploaded_art, user_uploaded_art = _e === void 0 ? '' : _e, _f = _a.sortBy, sortBy = _f === void 0 ? '' : _f, _g = _a.direction, direction = _g === void 0 ? 'asc' : _g, _h = _a.filter_ticket_number, filter_ticket_number = _h === void 0 ? '' : _h;
    var uri = "/arts?limit=".concat(per_page);
    if (status)
        uri += "&status=".concat(status);
    if (designer)
        uri += "&designer=".concat(designer);
    if (user_uploaded_art)
        uri += "&user_uploaded_art=".concat(user_uploaded_art);
    if (sortBy)
        uri += "&sortBy=".concat(sortBy);
    if (direction)
        uri += "&direction=".concat(direction);
    if (page)
        uri += "&page=".concat(page);
    if (filter_ticket_number)
        uri += "&filter_ticket_number=".concat(filter_ticket_number);
    return api.get(uri);
}
function getAllDesigners() {
    return api.get('/arts/designers');
}
function getAllArtsStatus() {
    return api.get('/arts/arts_status');
}
function getArtDisapprovalOptions() {
    return api.get("/arts/disapproval_arts");
}
function getContentSupplierProductGroups() {
    return api.get("/arts/content-supplier-product-groups");
}
function paginate(url, status, designer, user_uploaded_art, sortBy, direction) {
    url = (status === null || status === void 0 ? void 0 : status.length) === 0 ? url : url + "&status=".concat(status);
    url = (designer === null || designer === void 0 ? void 0 : designer.length) === 0 ? url : url + "&designer=".concat(designer);
    url = (user_uploaded_art === null || user_uploaded_art === void 0 ? void 0 : user_uploaded_art.length) === 0 ? url : url + "&user_uploaded_art=".concat(user_uploaded_art);
    url = (sortBy === null || sortBy === void 0 ? void 0 : sortBy.length) === 0 ? url : url + "&sortBy=".concat(sortBy);
    url = (direction === null || direction === void 0 ? void 0 : direction.length) === 0 ? url : url + "&direction=".concat(direction);
    return api.get(url);
}
function sendEmailApproved(ArtsData) {
    return api.post('/arts/send-email-approved', ArtsData);
}
function sendEmailDisapproved(ArtsData) {
    return api.post('/arts/send-email-disapproved', ArtsData);
}
function storeDesigner(payloadData) {
    return api.post("/arts/designer_and_status", payloadData);
}
function triggerStatusUpdate(artId) {
    return api.post("arts/trigger_status_update/".concat(artId));
}
export default {
    getAllTheArtsForTheDesigners: getAllTheArtsForTheDesigners,
    getAllDesigners: getAllDesigners,
    getAllArtsStatus: getAllArtsStatus,
    getArtDisapprovalOptions: getArtDisapprovalOptions,
    getContentSupplierProductGroups: getContentSupplierProductGroups,
    paginate: paginate,
    sendEmailApproved: sendEmailApproved,
    sendEmailDisapproved: sendEmailDisapproved,
    storeDesigner: storeDesigner,
    triggerStatusUpdate: triggerStatusUpdate
};
